<template>
	<search-list ref="sl" :pageSizes="[25,30,40,200]" apiPath="/dict/list" :where="where" :order="order" :searchKeys="searchKeys">
		<mm-lc title="Type">
			<!-- <el-select v-model="where.type" clearable>
        <el-option v-for="(item, key) in typeOptions" :key="key" :label="item.label" :value="item.value"></el-option>
      </el-select> -->
			<mm-dict-select v-model="where.type" dictType="dict_type" :defaultOptions="typeOptions" clearable></mm-dict-select>
		</mm-lc>
		<el-button slot="actions" type="success" class="el-icon-document-add" @click="openDetailDialog({})"></el-button>
		<div slot="actions" />
			<mm-table slot="dataTable" slot-scope="res" :res="res" @sort-change="sortChange">
			<el-table-column label="Name" prop="name" :show-overflow-tooltip="true" />
			<el-table-column label="Label" prop="label" />
			<el-table-column label="Type" prop="type" />
			<el-table-column label="action">
				<template slot-scope="sp">
					<el-dropdown szie="small" trigger="click" v-if="is_super_admin || sp.row.type != 'afSecret'">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item v-if="sp.row.type != 'afSecret'" @click.native="openDetailDialog(sp.row)">Edit</el-dropdown-item>
							<el-dropdown-item @click.native="delRow(sp.row)">Delete</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>

			</el-table-column>

		</mm-table>
		<el-dialog :visible.sync="detailVisible">
			<span slot="title">Dict Info</span>
			<el-form label-width="200px" :model="detailForm" ref="detailForm">
				<el-form-item label="Type" required prop="type">
					<mm-dict-select v-model="detailForm.type" dictType="dict_type" :defaultOptions="typeOptions"></mm-dict-select>
				</el-form-item>
				<el-form-item label="Name" required prop="name">
					<el-input v-model.trim="detailForm.name" style="width:300px"/>
				</el-form-item>
				<el-form-item label="Label" prop="label">
					<el-input v-model.trim="detailForm.label" style="width:300px"/>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="upsert()">Save</el-button>
				</el-form-item>
			</el-form>
    </el-dialog>
	</search-list>
</template>

<script>
import advTrackPlatform from '../components/adv/advTrackPlatform.vue';
export default {
	components: { advTrackPlatform },
	data() {
		const searchKeys = {
			label: { label: "Label" },
			name: { label: "Name" },
		};
    const user_info = this.$utils.getCookies(['user_name','group_name','is_super']);
    const is_super_admin = (user_info.group_name === 'admin'&&user_info.is_super=='1');
		return {
			searchKeys,
			where: {
        type: '',
			},
      detailVisible: false,
			order: [['update_at',-1]],
      typeOptions: [
        { label: 'Tracker', value: 'tracker' },
        { label: 'Track Platform', value: 'track_platform' },
        { label: 'Dict Type', value: 'dict_type' },
      ],
      detailForm: {
        name: '',
				label: '',
        type: '',
      },
			is_super_admin,
		};
	},
	methods: {
		openDetailDialog(row) {
      this.detailForm = row;
      this.detailVisible = true;
			setTimeout(() => {
				this.$refs.detailForm && this.$refs.detailForm.clearValidate();
			}, 0);
		},
    async upsert() {
			await this.$validate(this.$refs.detailForm);
      if (this.detailForm._id) {
        await this.$post('/dict/update', this.detailForm);
      } else {
        await this.$post('/dict/create', this.detailForm);
      }
      this.detailVisible = false;
      this.$refs.sl.refresh();
    },
    async delRow(row) {
      await this.$post('/dict/delete', { _id: row._id });
      this.$refs.sl.refresh();
    },
		async sortChange(column){
			const order = this.order;
			if(column.order == 'ascending'){
				order[0] = [column.prop, 1];
			}else if(column.order == 'descending'){
				order[0] = [column.prop, -1];
			}else {
				order[0] = ['update_at',-1];
			}
			await this.$refs.sl.refresh();
			this.order[0] = ['update_at',-1];
		},
	},

};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
